import type { CustomFile } from '../types';

import type { TypeUploadConfig, TypeUploadResult } from './types';
import type { TypeUploadContext } from './createUploadContext';
import uploadFiles from './uploadFiles';

// ----------------------------------------------------------------------------

/*
 * Pins the engine to a single in-flight request.
 */
async function uploadSequentialFiles(
    files: CustomFile[],
    config: TypeUploadConfig,
    context: TypeUploadContext,
): Promise<TypeUploadResult> {
    return uploadFiles(
        files,
        {
            ...config,
            // Object form so it outranks a flat `concurrency`/`maxConcurrency` the caller passed.
            concurrency: { enabled: true, max: 1 },
        },
        context,
    );
}

// ----------------------------------------------------------------------------

export default uploadSequentialFiles;
